import { module } from "angular";
import { ListGroupItemComponent } from "./ListGroupItemComponent";

module("mmGui").component("mmListGroupItem", new ListGroupItemComponent());
